'use client'

import React from 'react'
import { cn } from '@/utilities/ui'
import { Text } from './ui/text'
import { Heading } from './ui/heading'

export const Stat: React.FC<{
  variant?: 'dark' | 'light'
  value: string
  label: string
  className?: string
  size?: 'lg' | 'md'
}> = ({ value, label, className, size = 'md', variant = 'dark' }) => {
  return (
    <div className={cn('flex flex-col gap-[10px]', className)}>
      <Heading
        size={size === 'lg' ? 'h1' : 'h4'}
        className={cn('text-nowrap', variant === 'dark' ? 'text-dark' : 'text-slime')}
      >
        {value}
      </Heading>
      <Text
        size={size === 'lg' ? 'lg' : 'sm'}
        className={cn(variant === 'dark' ? 'text-dark' : 'text-light')}
      >
        {label}
      </Text>
    </div>
  )
}
